import React from "react"
import {MainCP} from "../../Components/dependiente_vs_independiente/MainCP"

const ViewDependientevsIndependiente: React.FC = () => <MainCP/>

export default ViewDependientevsIndependiente;